<template>
  <div class="animated fadeIn consultation-invite-sent">
    <b-card>
      <h4 class="mb-3">Payment link sent</h4>
      <p class="text-muted mb-4">
        The patient can pay on a short checkout page (no full registration form). After payment they verify their email with a one-time code, then the booking is confirmed.
      </p>

      <dl class="invite-details">
        <dt>Patient</dt>
        <dd>{{ patientLabel }}</dd>
        <dt>Email</dt>
        <dd>{{ email }}</dd>
        <dt>Payment link</dt>
        <dd class="link-row">
          <code class="payment-link">{{ paymentLink }}</code>
          <b-button size="sm" variant="outline-primary" @click="copyLink">Copy link</b-button>
        </dd>
      </dl>

      <div class="actions">
        <b-button variant="primary" :to="{ name: 'Patient', params: { patientId } }">Back to patient</b-button>
        <b-button variant="link" @click="goInvites">View consultation invites</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'ConsultationInviteSent',
  props: {
    patientId: { type: [String, Number], required: true }
  },
  data () {
    return {
      email: this.$route.query.email || '',
      paymentLink: this.$route.query.link || '',
      patientLabel: this.$route.query.name || ''
    }
  },
  methods: {
    copyLink () {
      if (!this.paymentLink) return
      navigator.clipboard.writeText(this.paymentLink).then(() => {
        this.$awn.success('Link copied')
      }).catch(() => {
        this.$awn.info('Copy the link from the box above')
      })
    },
    goInvites () {
      sessionStorage.setItem('patientsActiveTab', 'invites')
      this.$router.push({ name: 'Patients' })
    }
  }
}
</script>

<style scoped>
.invite-details dt {
  font-weight: 600;
  margin-top: 12px;
}
.link-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.payment-link {
  word-break: break-all;
  flex: 1;
  min-width: 200px;
}
.actions {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}
</style>
